import React from 'react';
import { Button } from '@mui/material';
import { Save as SaveIcon, Cancel as CancelIcon } from '@mui/icons-material';

interface InlineEditingControlsProps {
  onSave: () => void | Promise<void>;
  onCancel: () => void;
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  saveLabel?: string;
  cancelLabel?: string;
}

export const InlineEditingControls: React.FC<InlineEditingControlsProps> = ({
  onSave, onCancel, size, fullWidth, saveLabel = 'Save', cancelLabel = 'Cancel',
}) => (
  <>
    <Button variant="contained" size={size} fullWidth={fullWidth} startIcon={<SaveIcon />}
      onClick={() => void onSave()}>
      {saveLabel}
    </Button>
    <Button variant="outlined" size={size} fullWidth={fullWidth} startIcon={<CancelIcon />} onClick={onCancel}>
      {cancelLabel}
    </Button>
  </>
);
